export const iconTypes = Object.freeze({
  REPLY: 'reply',
  RATING: 'rating',
  COMMENT: 'comment',
  MENTION: 'mention',
  OFFICIAL_POST: 'official-post',
  CONTACTS_REMINDER: 'contacts-reminder',
  COMMISSION: 'commission',
});
